import { Table as ActionTypes } from '../actionTypes';

const initialState = [];

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET:
      return [...state, ...payload];
    case ActionTypes.SET_COLUMN:
      return state.reduce((list, item) => {
        if (item.Table === payload.Table) {
          list.push({ ...item, Columns: [...item.Columns, ...payload.Columns] });
        } else {
          list.push(item);
        }
        return list;
      }, []);
    default:
      return state;
  }
};
